export default __webpack_public_path__ + "static/media/etapa7.ff4f7183.png";